import type { PlotStatusKind } from '../../model/types';
import { getPlotStatusPresentation } from '../../lib/getPlotStatusPresentation';
import styles from './GenplanLegend.module.scss';

const legendItems: PlotStatusKind[] = [
  'price-per-sotka',
  'price-per-sotka-with-contractor',
  'reserved',
  'sold',
];

export function GenplanLegend() {
  return (
    <ul className={styles.legend} aria-label="Легенда статусов участков">
      {legendItems.map((kind) => {
        const status = getPlotStatusPresentation(kind);

        return (
          <li key={kind} className={styles.item}>
            <span className={styles.swatch} data-tone={status.tone} aria-hidden="true" />
            <span>{status.label}</span>
          </li>
        );
      })}
    </ul>
  );
}
